import React from "react";
import { Table } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

const InsuredDeposits = () => {
  const isMobile = useMediaQuery({ maxWidth: "1200px" });
  return (
    <div className="container ">
      <div className="my-5">
        <h1 style={{ fontWeight: "700", color: "#000045" }}>
          List of Insured Deposits
        </h1>
        <p style={{ color: "#72788E" }}>
          Protected by PIDM up to RM250,000 for each depositor
        </p>
        <p style={{ color: "#221AFB", fontWeight: "700" }}>
          Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (Member of
          PIDM){" "}
        </p>
      </div>
      <h5 className="text-center my-4">LIST OF INSURED DEPOSITS</h5>
      <Table responsive>
        <thead>
          <tr>
            <th></th>
            <th>Deposit Product Name</th>
            <th>Product Code</th>
            <th>Deposit Type</th>
            <th>Currency</th>
            <th>Shariah Contract</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              Al Rajhi Fixed Term Investment Account<em>-i</em>
              <br />
              <em>(also known as Mudharabah General Investment Account)</em>
            </td>
            <td>0350IR0500800001</td>
            <td>General Investment</td>
            <td>RM</td>
            <td>Unrestricted Mudarabah</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Commodity Murabahah Current Account<em>-i</em></td>
            <td>0350IR0100300001</td>
            <td>Demand Deposit</td>
            <td>RM</td>
            <td>Murabahah</td>
          </tr>
          <tr>
            <td>3</td>
            <td>
              Commodity Murabahah Deposit
              <br />
              <em>(also known as Commodity Murabahah Term Deposit<em>-i</em>)</em>
            </td>
            <td>0350IM0600300001</td>
            <td>Commodity Murabahah</td>
            <td>RM & Foreign</td>
            <td>Murabahah</td>
          </tr>
          <tr>
            <td>4</td>
            <td>
              Commodity Murabahah Foreign Currency Current Account<em>-i</em> (CM FCY
              CA<em>-i</em>)
            </td>
            <td>0350IF0100300001</td>
            <td>Demand Deposit</td>
            <td>Foreign</td>
            <td>Murabahah</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Commodity Murabahah Savings Account<em>-i</em></td>
            <td>0350IR0200300001</td>
            <td>Savings Deposit</td>
            <td>RM</td>
            <td>Murabahah</td>
          </tr>
          <tr>
            <td>6</td>
            <td>
              Current Account - Foreign Currency
              <br />
              <em>(also known as Qard Foreign Currency Current Account<em>-i</em>)</em>
            </td>
            <td>0350IF0100200002</td>
            <td>Demand Deposit</td>
            <td>Foreign</td>
            <td>Qard</td>
          </tr>
          <tr>
            <td>7</td>
            <td>
              Current Account-Qard
              <br />
              <em>(also known as Qard Current Account<em>-i</em>)</em>
            </td>
            <td>0350IR0100200002</td>
            <td>Demand Deposit</td>
            <td>RM</td>
            <td>Qard</td>
          </tr>
          <tr>
            <td>8</td>
            <td>
              Floating Rate Term Deposit
              <br />
              <em>(also known as Commodity Murabahah Floating Rate Term Deposit<em>-i</em>)</em>
            </td>
            <td>0350IR0600300012</td>
            <td>Commodity Murabahah</td>
            <td>RM</td>
            <td>Murabahah</td>
          </tr>
          <tr>
            <td>9</td>
            <td>
              Foreign Currency Account Musafir
              <br />
              <em>(also known as Qard Foreign Currency Current Account<em>-i</em>)</em>
            </td>
            <td>0350IF0100200003</td>
            <td>Demand Deposit</td>
            <td>Foreign</td>
            <td>Qard</td>
          </tr>
          <tr>
            <td>10</td>
            <td>Mudharabah Current Account</td>
            <td>0350IR0100800001</td>
            <td>Demand Deposit</td>
            <td>RM</td>
            <td>Unrestricted Mudarabah</td>
          </tr>
          <tr>
            <td>11</td>
            <td>
              Qard Savings Account
              <br />
              <em>(also known as Qard Savings Account<em>-i</em>)</em>
            </td>
            <td>0350IR0200200001</td>
            <td>Savings Deposit</td>
            <td>RM</td>
            <td>Qard</td>
          </tr>
          <tr>
            <td>12</td>
            <td>
              Wakalah Bi Al Istithmar Investment Account
              <br />
              <em>(also known as Wakalah Investment Account)</em>
            </td>
            <td>0350IR0501000001</td>
            <td>General Investment</td>
            <td>RM</td>
            <td>Unrestricted Wakalah</td>
          </tr>
        </tbody>
      </Table>
      <div className="pt-4">
        <p style={{ color: "#72788E" }}>
          For more information, kindly refer to the PIDM information brochures
          that are available at our branches or click 
          <a
            href="https://www.pidm.gov.my/pidm2022/files/e5/e57fb697-5b5f-4fe7-baa7-73478d7a3df5.pdf"
            target="blank"
          >
            here
          </a>
           for PIDM online brochure.{" "}
        </p>
      </div>
    </div>
  );
};

export default InsuredDeposits;
